<template>
  <Dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="1000px"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    append-to-body
    @closed="handleClosed"
  >
    <div class="video-player-wrap">
      <video
        v-if="videoUrl"
        ref="videoRef"
        class="video-player"
        :src="videoUrl"
        controls
        controlslist="nodownload"
        preload="metadata"
      >
        您的浏览器不支持 video 标签。
      </video>
      <div v-else class="video-empty">暂无视频地址</div>
    </div>
  </Dialog>
</template>

<script>
export default {
  name: "VideoPlayerDialog",
  data() {
    return {
      dialogVisible: false,
      videoUrl: "",
      title: "视频预览"
    };
  },
  methods: {
    open(url, title = "视频预览") {
      this.videoUrl = url || "";
      this.title = title;
      this.dialogVisible = true;
      this.$nextTick(() => {
        const video = this.$refs.videoRef;
        if (video) {
          video.load();
        }
      });
    },
    closeDialog(done) {
      this.pauseVideo();
      this.dialogVisible = false;
      done && done();
    },
    handleClosed() {
      this.pauseVideo();
      this.videoUrl = "";
      this.title = "视频预览";
    },
    pauseVideo() {
      const video = this.$refs.videoRef;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    }
  }
};
</script>

<style scoped lang="less">
.video-player-wrap {
  width: 100%;
  background: #000;
  border-radius: 4px;
  overflow: hidden;
}

.video-player {
  display: block;
  width: 100%;
  max-height: 450px;
  outline: none;
}

.video-empty {
  height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayerDialog.vue